/* eslint-disable react/no-multi-comp */
import React from 'react';
import { Dropdown, theme } from '@app/ui';
import { useTranslation } from 'react-i18next';
import './campaignsTable.scss';

const MenuItemVerticalPopoverMenu = ({
    id,
    editCampaign,
    deleteCampaign,
}: {
    id: number;
    editCampaign: (id: number) => void;
    deleteCampaign: (id: number) => Promise<void>;
}) => {
    const { t } = useTranslation('ownedSocial');
    const [isHoveringTableLink, setIsHoveringTableLink] = React.useState(null);
    const {
        token: { colorPrimary },
    } = theme.useToken();

    const items = [
        {
            key: '1',
            label: (
                <a
                    onClick={() => editCampaign(id)}
                    onMouseEnter={() => setIsHoveringTableLink('1')}
                    onMouseLeave={() => setIsHoveringTableLink(null)}
                    style={{
                        color:
                            isHoveringTableLink === '1'
                                ? colorPrimary
                                : undefined,
                    }}
                >
                    {t('socialPostMetrics.editCampaign')}
                </a>
            ),
            icon: (
                <i
                    className="fa-regular fa-pen"
                    style={{
                        color:
                            isHoveringTableLink === '1'
                                ? colorPrimary
                                : undefined,
                    }}
                />
            ),
        },
        {
            key: '2',
            label: (
                <a
                    onClick={async () => {
                        const confirmation = confirm(
                            t('socialPostMetrics.deleteCampaignConfirmation'),
                        );
                        if (!confirmation) return;
                        await deleteCampaign(id);
                    }}
                    onMouseEnter={() => setIsHoveringTableLink('2')}
                    onMouseLeave={() => setIsHoveringTableLink(null)}
                    style={{
                        color:
                            isHoveringTableLink === '2'
                                ? colorPrimary
                                : undefined,
                    }}
                >
                    {t('socialPostMetrics.deleteCampaign')}
                </a>
            ),
            icon: (
                <i
                    className="fa-regular fa-trash"
                    style={{
                        color:
                            isHoveringTableLink === '2'
                                ? colorPrimary
                                : undefined,
                    }}
                />
            ),
        },
    ];

    return (
        <Dropdown menu={{ items }}>
            <div className="campaigns-table-dropdown-trigger">
                <i
                    className="fa-solid fa-ellipsis-vertical"
                    style={{
                        fontSize: 16,
                        color: colorPrimary,
                    }}
                />
            </div>
        </Dropdown>
    );
};

export default MenuItemVerticalPopoverMenu;
